module.exports = __webpack_public_path__ + "img/denmark-tuberculosis-male.dea3262b.png";